export const ADVANCED_TECHNOLOGY_PAGE = "/pages/advanced-technology/";
export const CUSTOM_DESIGN_PAGE = "/pages/custom-design/";
export const SUSTAINABILITY_PAGE = "/pages/sustainability/";
export const CUTTING_COSTS_PAGE = "/pages/cutting-costs/";
export const ABOUT_US_PAGE = "/pages/about-us/";
export const NEWS_PAGE = "/pages/news/";
export const PRIVACY_POLICY_PAGE = "/privacy-policy/";
export const LEGAL_NOTICE_PAGE = "/imprint/legal-notice/";
export const NEWS_POST_PAGE = "/news/";
// Form pages
export const ASK_ABOUT_OUR_TECH_PAGE = "/forms/ask-about-our-tech/";
export const COST_YOUR_PROJECT_PAGE = "/forms/cost-your-project-now/";
export const FIND_OUT_MORE_PAGE = "/forms/find-out-more/";
export const GET_IN_TOUCH_PAGE = "/forms/get-in-touch/";
export const JOIN_OUR_MAILING_LIST_PAGE = "/forms/join-our-mailing-list/";
export const WORK_WITH_US_PAGE = "/forms/work-with-us/";
// News pages
